import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportGedExternoUseCase } from "../../../presentation/useCases/read/get_report_ged_externo_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportGedExternoUseCase
 */

export class GetReportGedExternoUseCase implements IGetReportGedExternoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportGedExterno(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportGedExterno(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `ged_externo_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }

    return response;
  }
}
